(function () {
  'use strict';
  angular
      .module('irricrops')
      .controller('vinedoSeguimientoCtrl', vinedoSeguimientoCtrl);

  vinedoSeguimientoCtrl.$inject = ['vinedo', 'global', 'menu', '$stateParams', 'cuartelDialog', '$q','estadisticaFac',
    'seguimientoRes', 'temporadaFac', 'Config', 'MultiChart','urls', '$http', '$scope', '$timeout', 'CuartelRes', '$mdDialog'];

  /* @ngInject */
  function vinedoSeguimientoCtrl(vinedo, global, menu, $stateParams, cuartelDialog, $q, estadisticaFac,
                                 seguimientoRes, temporadaFac, Config, MultiChart, urls, $http, $scope, $timeout, CuartelRes, $mdDialog){

    var vm                    = this;
    var vinedoId              = $stateParams.id;
    var lastDataGrafico       = null;
    var hideBackdropCallback = null;
    vm.limitComparison       = 2;
    vm.vinedo                = vinedo.data;
    vm.equipos               = [];
    vm.temporadas             = [];
    vm.alertEmptySelect       = false;
    vm.volumenTotal           = 0;
    vm.volumenTotalHA         = 0;
    vm.fechaInicioGradosDia_m = null;
    vm.filtros                = {};
    vm.dateSelected           = new Date();
    vm.optionsChanged         = false;
    vm.isMobile               = false;
    vm.loadingGeneral         = false;
    vm.firstLoad              = true;
    vm.temporadaSelected      = {
      periodo: null
    };
    vm.temporadaActiva                  = {};
    vm.temporadasComparisonArray        = [];
    vm.comparando                       = false;
    vm.showTabsComparacion              = vm.comparando || vm.comparandoSectores;
    vm.comparandoSectores               = false;
    vm.showAddComparison                = true;
    vm.volumenes                        = [];
    vm.sectoresSeleccionados            = [];
    vm.sectoresSeleccionadosComparacion = [];


    vm.showedBackdrop  = false;
    vm.showPopoverDate = false;

    vm.chart             = {
      loadingChart : true,
      chartConfig  : null
    };

    vm.nameFiltros = [
        "calidadSelected",
        "variedadSelected",
        "clonSelected",
        "especieSelected",
        "portaInjertoSelected",
        "sistemaConduccionSelected"
    ];

    var months = ["Junio",
                  "Julio",
                  "Agosto",
                  "Septiembre",
                  "Octubre",
                  "Noviembre",
                  "Diciembre",
                  "Enero",
                  "Febrero",
                  "Marzo",
                  "Abril",
                  "Mayo"];


    var PERIODO_FENOLOGIA = {
      nombre : "Periodos",
      enabled: true
    };
    var PERIODO_MESES     = {
      nombre : "Meses",
      enabled: true
    };

    vm.PERIODO_FENOLOGIA = PERIODO_FENOLOGIA;
    vm.PERIODO_MESES     = PERIODO_MESES;
    vm.periodos          = [PERIODO_FENOLOGIA, PERIODO_MESES];
    vm.periodoSelected   = PERIODO_MESES;







    var PERIODO_S_TEMPORADA = {
      nombre : "temporada",
    };
    var PERIODO_S_MES = {
      nombre : "30 dias",
    };
    var PERIODO_S_2_SEMANA  = {
      nombre : "15 dias",
    };
    var PERIODO_S_SEMANA  = {
      nombre : "7 dias",
    };

    vm.PERIODO_S_TEMPORADA = PERIODO_S_TEMPORADA;
    vm.PERIODO_S_MES       = PERIODO_S_MES;
    vm.PERIODO_S_2_SEMANAS = PERIODO_S_2_SEMANA;
    vm.PERIODO_S_SEMANAS   = PERIODO_S_SEMANA;

    vm.periodosSectores = [
      PERIODO_S_TEMPORADA,
      PERIODO_S_MES,
      PERIODO_S_2_SEMANA,
      PERIODO_S_SEMANA,
    ];

    vm.periodoSectorSelected = PERIODO_S_MES;











    vm.dataHttp = {
      vinedo_id : vinedoId,
      periodo   : vm.temporadaSelected.periodo
    };

    vm.cantidadSemanasArray = [
      {
        num: 1,
        label: "1 Semana"
      },
      {
        num: 2,
        label: "2 Semanas"
      },
      {
        num: 3,
        label: "3 Semanas"
      }
    ];

    vm.cantidadSemanasSelected = vm.cantidadSemanasArray[0];
    vm.inicioSemana = moment(vm.dateSelected).subtract(vm.cantidadSemanasSelected.num - 1, "week").startOf('week').isoWeekday(1).format("DD/MM/YYYY");
    vm.finSemana    = moment(vm.dateSelected).endOf('week').format("DD/MM/YYYY");








    var GENERAL_VIEW = {
      id: 1,
      name: "general",
      loaded:false
    };
    var DETAIL_VIEW = {
      id: 2,
      name: "detalle",
      loaded:false
    };

    vm.GENERAL_VIEW = GENERAL_VIEW;
    vm.DETAIL_VIEW = DETAIL_VIEW;

    vm.views = [
      GENERAL_VIEW,
      DETAIL_VIEW
    ];
    vm.viewSelected = GENERAL_VIEW;











    vm.tabs = {
      mchartGD  : {},
      mchartRep : {},
      mchartEt  : {},
      mchartVol : {}
    }

    vm.tab_gd = {
      name:"Grados Dia",
      tag:"gd"
    };

    vm.tab_deltaGD = {
      name:"Delta GD",
      tag:"deltaGD"
    };

    vm.tab_winkler = {
      name:"Winkler",
      tag:"winkler"
    };

    vm.tab_deltaWinkler = {
      name:"delta Winkler",
      tag:"deltaWinkler"
    };

    vm.tabs.mchartGD.tabs= [
      vm.tab_deltaGD,
      vm.tab_gd,
      vm.tab_deltaWinkler,
      vm.tab_winkler
    ];

    vm.tabs.mchartGD.tabSelected = vm.tab_gd;










    vm.tabRep_reposicion = {
      name:"Prom Reposición",
      tag: "reposicion"
    }

    vm.tabRep_rep_teorica = {
      name:"Rep Teórica",
      tag: "rep_teorica"
    }

    vm.tabRep_rep_real_eto = {
      name:"Rep Real Eto",
      tag: "rep_real_eto"
    }

    vm.tabRep_rep_real_etb = {
      name:"Rep Real Etb",
      tag: "rep_real_etb"
    }

    vm.tabs.mchartRep.tabs = [
      vm.tabRep_reposicion,
      vm.tabRep_rep_teorica,
      vm.tabRep_rep_real_eto,
      vm.tabRep_rep_real_etb
    ];

    if(Config.vinedo['estacionMet']){
      vm.tabs.mchartRep.tabSelected = vm.tabRep_rep_real_eto;
    }else{
      vm.tabs.mchartRep.tabSelected = vm.tabRep_rep_real_etb;
    }









    vm.tabVol_vol_ha = {
      name: "m3/ha",
      tag: "vol_ha"
    }

    vm.tabVol_vol_ha_acum = {
      name: "m3/ha Acumulada",
      tag: "vol_ha_acum",
    }

    vm.tabVol_vol_ha_etb = {
      name: "m3/ha teorico Etb",
      tag: "vol_ha_etb"
    }

    vm.tabVol_vol_ha_eto = {
      name: "m3/ha teorico Eto",
      tag: "vol_ha_eto"
    }

    vm.tabVol_schol = {
      name: "Scholander",
      tag: "scholander",
      visible: Config.vinedo.conScholander
    }

    vm.tabVol_vol_ha_total = {
      name: "m3/ha Total",
      tag: "vol_ha_total"
    }

    vm.tabs.mchartVol.tabs = [
      vm.tabVol_vol_ha,
      vm.tabVol_vol_ha_acum,
      vm.tabVol_vol_ha_etb,
      vm.tabVol_vol_ha_eto,
      vm.tabVol_schol
    ];

    vm.tabs.mchartVol.tabSelected = vm.tabVol_vol_ha;





    vm.tabEt_eto = {
      name: "Eto",
      tag: "eto"
    }

    vm.tabEt_etb = {
      name: "Etb",
      tag: "etb"
    }

    vm.tabEt_eto_prom = {
      name: "Eto promedio",
      tag: "eto_prom"
    }

    vm.tabEt_etb_prom = {
      name: "Etb promedio",
      tag: "etb_prom"
    }

    vm.tabEt_coeficiente = {
      name: "Coeficiente",
      tag: "coef"
    }

    vm.tabs.mchartEt.tabs = [
      vm.tabEt_eto,
      vm.tabEt_etb,
      vm.tabEt_eto_prom,
      vm.tabEt_etb_prom,
      vm.tabEt_coeficiente
    ];

    vm.tabs.mchartEt.tabSelected = vm.tabEt_eto;
























   // -------------------------------------------------------------
   // ----------- INIT --------------------------------------------
   // -------------------------------------------------------------


    vm.init = function () {
      //obtencion de datosde temporadas
      refreshTemporadas(function (res) {

        vm.temporadaSelected      = temporadaFac.getActiva();
        vm.temporadaActiva        = temporadaFac.getActiva();
        vm.fechaInicioGradosDia_m = moment(vm.temporadaSelected.inicio, "YYYY-MM-DD").toDate();

        // obtencion de datos para grados dias
        var ta1                   = temporadaFac.getAnterior(vm.temporadaSelected);
        var ta2                   = temporadaFac.getAnterior(ta1);

        PERIODO_FENOLOGIA.enabled = vm.temporadaSelected.estados;

        var p1Http = {
          vinedo_id: vinedoId,
          periodo: vm.temporadaSelected.periodo
        };
        var p1 = seguimientoRes.gradosDias(p1Http).$promise;


        var p2Http = {
          vinedo_id: vinedoId,
          periodo: ta1.periodo
        };
        var p2 = seguimientoRes.gradosDias(p2Http).$promise;

        var p3Http = {
          vinedo_id: vinedoId,
          periodo: ta2.periodo
        };
        var p3 = seguimientoRes.gradosDias(p3Http).$promise;

        var paramsHttp = [p1Http, p2Http, p3Http];
        var promises = [p1, p2, p3];

        $q.all(promises)
          .then(function(resgd){
            var dataGd = [];

            _.each(resgd, function(gdArray, index){
              dataGd.push({
                data: gdArray.data,
                periodo : paramsHttp[index].periodo
              });
            });

            vm.dataGradosDias = dataGd;
            vm.recalcularGradosDias();
        });
        // END obtencion de datos para grados dias
      });
    };








    vm.reload = function () {
      vm.firstLoad      = false;
      vm.loadingGeneral = true;
      vm.optionsChanged = false;
      vm.etAcum         = undefined;
      vm.volumenes      = [];

      refreshTemporadas(function (res) {

        var dataHttp = angular.copy(vm.dataHttp);


        if(vm.viewSelected == GENERAL_VIEW){
          switch (vm.periodoSelected){
            case PERIODO_FENOLOGIA:
              vm.getDatosAnalisisGeneral(dataHttp, "fenologia");
              break;
            case PERIODO_MESES:
              vm.getDatosAnalisisGeneral(dataHttp, "meses");
              break;
            default:
              console.error("item no encontrado");
              vm.loadingGeneral = false;
          }
        }


        if(vm.viewSelected == DETAIL_VIEW){
          switch (vm.periodoSectorSelected){
            case PERIODO_S_TEMPORADA:
              vm.showDetalleSectores();
              break;
            case PERIODO_S_MES:
              vm.showDetalleSectores(30);
              break;
            case PERIODO_S_2_SEMANA:
              vm.showDetalleSectores(15);
              break;
            case PERIODO_S_SEMANA:
              vm.showDetalleSectores(7);
              break;
            default:
              console.error("item no encontrado");
              vm.loadingGeneral = false;
          }
        }


      });
    };




    vm.showByTag = function(mchartName, tab){
      var mchart = vm.generalCharts[mchartName];
      if(mchart === undefined){
        return;
      }
      mchart.hideAllSeries({
        hideLegend: true,
        redraw: false
      });
      mchart.toggleVisibleSeriesByTag(tab.tag);
      vm.tabs[mchartName].tabSelected = tab;
    }


    menu.getSidebarProm().then(function(){
      vm.equipos = global.getSidebarData(vinedoId).equipos;
    });








    //--------------------------------------------------------------------------
    //------ VISTA GENERAL -------------------------------------------
    //--------------------------------------------------------------------------

    vm.getDatosAnalisisGeneral = function (dataHttp, fn) {
      var promises      = [];
      var dh            = angular.copy(dataHttp);       //para evitar problema de variable por referencia
      var periodos      = [];
      var dateSelected  = angular.copy(vm.dateSelected);// para periodo semanas
      dh.fecha_busqueda = moment().format("DD-MM-YYYY");

      //fn puede ser meses, semanas, fenologia
      var prom     = seguimientoRes[fn](dh).$promise;
      prom.periodo = vm.temporadaSelected.periodo;

      promises.push(prom);
      periodos.push(vm.temporadaSelected.periodo);



      if(vm.comparando){
        _.each(vm.temporadasComparisonArray, function(temporada){

          dh.periodo        = temporada.selected.periodo;
          var temporadaDate = temporadaFac.dateToTemporada(dateSelected);
          var diffYear      = parseInt(temporadaDate.periodo.split("-")[0]) - parseInt(dh.periodo.split("-")[0]);
          dh.fecha_busqueda = moment().subtract(diffYear, "years").format("DD-MM-YYYY");
          var prom          = seguimientoRes[fn](dh).$promise
          prom.periodo      = dh.periodo;

          promises.push(prom);
          periodos.push(dh.periodo);
        })
      }


      //TODO
      if(vm.comparandoSectores && vm.sectoresSeleccionadosComparacion.length > 0){

        //agregar promesas de sectores seleccionados
        var dhComparacion                    = angular.copy(dataHttp);
        dhComparacion.fecha_busqueda         = moment().format("DD-MM-YYYY");
        dhComparacion["sectores_riego_id[]"] = vm.sectoresSeleccionadosComparacion.map(s => s.id);
        var prom                             = seguimientoRes[fn](dhComparacion).$promise;
        prom.periodo                         = vm.temporadaSelected.periodo;
        prom.isSectorComparison              = true;
        prom.color                           = "indigo";
        // solo usa un sector, verificar si se deben hacer en varios
        prom.sectoresComparison              = vm.sectoresSeleccionadosComparacion;
        promises.push(prom);
        periodos.push(vm.temporadaSelected.periodo);
      }


      promises.sort(function(a, b){
        var ai = promises.indexOf(a);
        var bi = promises.indexOf(b);
        var pi = periodos[ai];
        var pf = periodos[bi];
        pi = parseInt(pi.split("-")[0]);
        pf = parseInt(pf.split("-")[0]);
        return pi - pf;
      });

      periodos.sort(function(a, b){
        var pi = parseInt(a.split("-")[0]);
        var pf = parseInt(b.split("-")[0]);
        return pi - pf;
      });



      $q.all(promises).then(function(resArray, a, b, c){
        PERIODO_MESES.enabled = true;
        _.each(resArray, function(res, index){

          //if(!res.$promise.isSectorComparison){
            vm.volumenes.push({
              color          : res.$promise.color || "green",
              label          : res.$promise.periodo,
              total          : res.data.total.volumen_total,
              total_ha       : res.data.total.volumen_ha,
              total_fecha    : res.data.total.volumen_fecha,
              total_fecha_ha : res.data.total.volumen_ha_fecha,
            });
          //}



          if(index == 0){ // TEMPORADA SELECCIONADA
            if(res.data.datos.length > 0){
              PERIODO_FENOLOGIA.enabled = true;
            }else{
              vm.selectPeriodo(PERIODO_MESES, true);
            }
          }

          var sectorComparisonName = "";
          if(res.$promise.isSectorComparison){
            if(prom.sectoresComparison.length == 1){
              sectorComparisonName = prom.sectoresComparison[0].nombre;
            }else{
              sectorComparisonName = "comparación";
            }
            sectorComparisonName = " <i class='md-blue'>"+sectorComparisonName+"</i>";
          }

          vm.graficarVistaGeneral({
            data             : res.data.datos,
            makeNewCharts    : index == 0,
            withGradosDias   : index == 0,
            withEt           : !(vm.comparandoSectores && res.$promise.isSectorComparison),
            withLabelPeriodo : vm.comparando,
            labelSector      : vm.comparandoSectores ? sectorComparisonName : "",
            periodo          : periodos[index],
            isActive         : periodos[index] == vm.temporadaActiva.periodo,
            index            : index
          });

          vm.showTabsComparacion = vm.comparando || vm.comparandoSectores;

        })
        vm.loadingGeneral = false;
      });
    };




    function makeGeneralCharts(){
      var g = {};

      //g.mchartRiego      = new MultiChart("Seguimiento de Riegos");
      g.mchartRep = new MultiChart("Seguimiento de Reposición");
      g.mchartEt  = new MultiChart("Seguimiento de Evapotranspiración");
      g.mchartGD  = new MultiChart("Seguimiento de Grados Dias");

      if(Config.vinedo.conScholander){
        g.mchartVol = new MultiChart("Seguimiento de Volumen y Scholander");
      }else{
        g.mchartVol   = new MultiChart("Seguimiento de Volumen");
      }

      g.mchartRep.setSubtitle(vm.vinedo.nombre);
      g.mchartEt.setSubtitle(vm.vinedo.nombre);
      g.mchartGD.setSubtitle(vm.vinedo.nombre);
      g.mchartVol.setSubtitle(vm.vinedo.nombre);

      g.mchartRep.deletePositioner();
      g.mchartEt.deletePositioner();
      g.mchartVol.deletePositioner();
      g.mchartGD.deletePositioner();

      g.mchartRep.xAxisRotation(0);
      g.mchartEt.xAxisRotation(0);
      g.mchartVol.xAxisRotation(0);
      g.mchartGD.xAxisRotation(0);

      if(vm.periodoSelected == PERIODO_MESES){
        g.mchartGD.setEjeX(
          months, false
        )
      }

      var isMMVisible = false;
      g.mchartVol.addContextButton("changeMode", {
        x        : -30,
        y        : 0,
        text     : "m<sup>3</sup> <> mm",
        className: "changeMode",
        onclick  : function () {
          isMMVisible = !isMMVisible;
          g.mchartVol.toggleSeriesByTag("riegomm", isMMVisible);
          g.mchartVol.toggleSeriesByTag("vol_ha", !isMMVisible);
          $timeout(function(){
            g.mchartVol.redraw();
          }, 100)
        }
      });

      vm.generalCharts = g;

      return g;
    }






    vm.graficarVistaGeneral = function(paramsFn){
      var data             = paramsFn.data;
      var indexColor       = paramsFn.index;
      var makeNewCharts    = paramsFn.makeNewCharts     == undefined ? true : paramsFn.makeNewCharts;
      var withGD           = paramsFn.withGradosDias    == undefined ? true : paramsFn.withGradosDias;
      var withEt           = paramsFn.withEt            == undefined ? true : paramsFn.withEt;
      var withLabelPeriodo = paramsFn.withLabelPeriodo  == undefined ? true : paramsFn.withLabelPeriodo;
      var withLabelSector  = paramsFn.labelSector       == undefined ? true : paramsFn.labelSector;
      var suffixLabel      = "";
      var isActiveTabs     = vm.comparando || vm.comparandoSectores;


      if(data !== undefined){
        lastDataGrafico = data;
      }else{
        var data = lastDataGrafico;
      }

      var g = null; //VARIABLE QUE CONTENDRE LOS GRAFICOS

      if(makeNewCharts){
        g = makeGeneralCharts();
      }else{
        g = getGeneralCharts();
      }


      if(withLabelPeriodo){
        suffixLabel = " "+paramsFn.periodo;
      }

      if(withLabelSector){
        suffixLabel = " "+paramsFn.labelSector;
      }

      // INICIALIZA DATOS
      var d              = initDataCharts(data);
      var dataParams     = d.dataParams;
      var dataLabels     = d.dataLabels;
      var datesGradosDia = d.datesGradosDia;

      //MCHART RIEGO ( heredado de graficar(); )
      g.mchartVol.agregarSerie({
        //color        : Config.colors.riegoReal.background,
        color       : Config.colors.riegoReal.array[indexColor],
        name         : 'Riego Real '+ suffixLabel ,
        tag          : "riegomm",
        yAxis        : 2,
        type         : 'column',
        data         : dataParams.riego_real,
        labelsData   : dataLabels.riego_real,
        suffix       : ' mm',
        required     : true,
        visible      : false,
        showInLegend : false,
        visibleAxis  : true,
      });

      /*
      g.mchartRiego.agregarSerie({
        color       : Config.colors.etb.background,
        name        : 'Riego teorica Etb',
        yAxis       : 2,
        type        : 'column',
        data        : dataParams.riego_teorico_etb,
        labelsData  : dataLabels.riego_teorico_etb,
        suffix      : ' mm',
        required    : true,
        visibleAxis : true,
        visible: Config.vinedo['estacionMet'] ? false : true
      });

      g.mchartRiego.agregarSerie({
        color       : Config.colors.et0.background,
        name        : 'Riego teórica Eto',
        yAxis       : 2,
        type        : 'column',
        data        : dataParams.riego_teorico_eto,
        labelsData  : dataLabels.riego_teorico_eto,
        suffix      : ' mm',
        required    : true,
        visibleAxis : true,
        visible: Config.vinedo['estacionMet'] ? true : false
      });
      */




      //MCHART VOLUMEN
      g.mchartVol.agregarSerie({
        color       : Config.colors.volumen.array[indexColor],
        name        : 'm<sup>3</sup>/ha' + suffixLabel ,
        tag         : 'vol_ha',
        yAxis       : 7,
        type        : 'column',
        data        : dataParams.volumen_ha,
        labelsData  : dataLabels.volumen_ha,
        suffix      : ' m3/ha',
        required    : true,
        visibleAxis : true,
        //showInLegend : !vm.comparando
      });



      g.mchartVol.agregarSerie({
        color       : Config.colors.volumen.array[indexColor],
        name        : 'm<sup>3</sup>/ha Acumulada' + suffixLabel ,
        tag         : 'vol_ha_acum',
        yAxis       : 7,
        type        : 'spline',
        lineWidth   : 2,
        data        : dataParams.volumen_ha_acum,
        labelsData  : dataLabels.volumen_ha_acum,
        suffix      : ' m3/ha',
        required    : true,
        visibleAxis : true,
        visible: false,
        showInLegend : !isActiveTabs
      });



      /*
      var labelsEtb = concatLabelsData(dataLabels.volumen_ha_teorico_etb, dataLabels.volumen_dif_etb);
      g.mchartVol.agregarSerie({
        //color       : Config.colors.etb.background,
        color       : Config.colors.etb.array[indexColor],
        name        : 'm<sup>3</sup>/ha teórico etb' + suffixLabel ,
        tag         : 'vol_ha_etb',
        yAxis       : 7,
        type        : 'column',
        data        : dataParams.volumen_ha_teorico_etb,
        labelsData  : labelsEtb,
        suffix      : ' m3/ha',
        required    : true,
        visibleAxis : true,
        visible     : (Config.vinedo['estacionMet'] || vm.comparando) ? false : true,
        showInLegend : !vm.comparando
      });

      var labelsEto = concatLabelsData(dataLabels.volumen_ha_teorico_eto, dataLabels.volumen_dif_eto);
      g.mchartVol.agregarSerie({
        color       : Config.colors.et0.array[indexColor],
        name        : 'm<sup>3</sup>/ha teórico et0' + suffixLabel ,
        tag         : 'vol_ha_eto',
        yAxis       : 7,
        type        : 'column',
        data        : dataParams.volumen_ha_teorico_eto,
        labelsData  : labelsEto,
        suffix      : ' m3/ha',
        required    : true,
        visibleAxis : true,
        visible     : (Config.vinedo['estacionMet'] && !vm.comparando) ? true : false,
        showInLegend : !vm.comparando
      });
      */




      g.mchartVol.agregarSerie({
        color       : Config.colors.volumen.array[indexColor],
        name        : 'm<sup>3</sup> total' + suffixLabel ,
        tag         : 'vol_ha_total',
        yAxis       : 7,
        type        : 'column',
        data        : dataParams.volumen_total,
        labelsData  : dataLabels.volumen_total,
        suffix      : ' m3',
        required    : true,
        visibleAxis : true,
        visible     : false,
        showInLegend : !isActiveTabs
      });

      g.mchartVol.agregarSerie({
        color        : Config.colors.scholander.array[indexColor],
        name         : 'Bomba Scholander' + suffixLabel ,
        tag          : "scholander",
        markerSymbol : 'circle',
        type         : "spline",
        radius       : 3,
        yAxis        : 1,
        preffix      : '-',
        suffix       : ' bar',
        visibleAxis  : true,
        oppositeAxis : true,
        labelsData   : dataLabels.scholander,
        data         : dataParams.scholander,
        visible      : !isActiveTabs,
        showInLegend : !isActiveTabs
      });











      //MCHART REPOSICION

      g.mchartRep.agregarSerie({
        color       : Config.colors.promedioReposicion.array[indexColor],
        name        : 'Promedio Reposiciones' + suffixLabel ,
        tag         : 'reposicion',
        type        : 'spline',
        yAxis       : 12,
        lineWidth   : 2,
        preffix     : '',
        suffix      : ' %',
        visible     : !isActiveTabs,
        showInLegend : !isActiveTabs,
        visibleAxis : true,
        data        : dataParams.reposicion,
        labelsData  : dataLabels.reposicion,
      });

      g.mchartRep.agregarSerie({
        color       : Config.colors.porcentajeIdeal.array[indexColor],
        name        : 'Reposicion Teórica' + suffixLabel ,
        tag         : 'rep_teorica',
        type        : 'spline',
        yAxis       : 12,
        lineWidth   : 2,
        preffix     : '',
        suffix      : ' %',
        visible     : !isActiveTabs,
        showInLegend : !isActiveTabs,
        visibleAxis : true,
        data        : dataParams.reposicion_ideal,
        labelsData  : dataLabels.reposicion_ideal,
      });


      g.mchartRep.agregarSerie({
        color       : Config.colors.et0.array[indexColor],
        name        : 'Reposicion Real ET0' + suffixLabel ,
        tag         : 'rep_real_eto',
        type        : 'spline',
        yAxis       : 12,
        lineWidth   : 2,
        preffix     : '',
        suffix      : ' %',
        visibleAxis : true,
        data        : dataParams.reposicion_eto,
        labelsData  : dataLabels.reposicion_eto,
        visible     : ((!isActiveTabs)|| (isActiveTabs && vm.tabs.mchartRep.tabSelected == vm.tabRep_rep_real_eto)),
        showInLegend : ((!isActiveTabs)|| (isActiveTabs && vm.tabs.mchartRep.tabSelected == vm.tabRep_rep_real_eto)),
      });




      g.mchartRep.agregarSerie({
        color       : Config.colors.etb.array[indexColor],
        name        : 'Reposicion Real Etb' + suffixLabel ,
        tag         : 'rep_real_etb',
        type        : 'spline',
        yAxis       : 12,
        lineWidth   : 2,
        preffix     : '',
        suffix      : ' %',
        visibleAxis : true,
        data        : dataParams.reposicion_etb,
        labelsData  : dataLabels.reposicion_etb,
        visible     : ((!isActiveTabs) || (isActiveTabs && vm.tabs.mchartRep.tabSelected == vm.tabRep_rep_real_etb)),
        showInLegend : ((!isActiveTabs) || (isActiveTabs && vm.tabs.mchartRep.tabSelected == vm.tabRep_rep_real_etb)),
      });






      if(withEt){

        //para mostrar promedios en el grafico de Et
        //por defecto usa Et0, si no usa estacion (osea, usa bandeja), carga etb
        var mchartEt_initial_label = "eto_prom";
        vm.tabs.mchartEt.tabSelected = vm.tabEt_eto_prom;

        if(!Config.vinedo['estacionMet']){
          mchartEt_initial_label = "etb_prom";
          vm.tabs.mchartEt.tabSelected = vm.tabEt_etb_prom;
        }


        //MCHART ET
        var visible = false;
        if(vm.comparando){
          visible = mchartEt_initial_label == "eto";
        }
        g.mchartEt.agregarSerie({
          color        : Config.colors.et0.array[indexColor],
          name         : 'Et0' + suffixLabel ,
          tag          : 'eto',
          yAxis        : 13,
          suffix       : ' mm',
          type         : 'column',
          data         : dataParams.eto,
          labelsData   : dataLabels.eto,
          visibleAxis  : true,
          //visible: Config.vinedo['estacionMet'] ? true : false
          //visible     : false,
          visible      : visible,
          showInLegend : (!isActiveTabs || mchartEt_initial_label == "eto")
        });



        visible = false;
        if(isActiveTabs ){
          visible = mchartEt_initial_label == "etb";
        }

        g.mchartEt.agregarSerie({
          color        : Config.colors.etb.array[indexColor],
          labelsColor  : Config.colors.etb.array[indexColor],
          name         : 'Etb' + suffixLabel ,
          tag          : "etb",
          yAxis        : 13,
          suffix       : ' mm',
          type         : 'column',
          data         : dataParams.etb,
          labelsData   : dataLabels.etb,
          visibleAxis  : true,
          //visible: Config.vinedo['estacionMet'] ? false : true
          visible      : visible,
          showInLegend : (!isActiveTabs || mchartEt_initial_label == "etb")
        });




        visible = Config.vinedo['estacionMet'] ? true : false;
        if(isActiveTabs ){
          visible = mchartEt_initial_label == "eto_prom";
        }

        g.mchartEt.agregarSerie({
          color       : Config.colors.et0.array[indexColor],
          labelsColor  : Config.colors.et0.array[indexColor],
          name         : 'Et0 promedio' + suffixLabel ,
          tag          : "eto_prom",
          yAxis        : 13,
          suffix       : ' mm',
          type         : 'column',
          data         : dataParams.x_eto,
          labelsData   : dataLabels.x_eto,
          visibleAxis  : true,
          visible      : visible,
          showInLegend : (!isActiveTabs || mchartEt_initial_label == "eto_prom")
        });



        visible = Config.vinedo['estacionMet'] ? false : true;
        if(isActiveTabs ){
          visible = mchartEt_initial_label == "etb_prom";
        }

        g.mchartEt.agregarSerie({
          color       : Config.colors.etb.array[indexColor],
          labelsColor : Config.colors.etb.array[indexColor],
          name        : 'Etb promedio' + suffixLabel ,
          tag         : "etb_prom",
          yAxis       : 13,
          suffix      : ' mm',
          type        : 'column',
          data        : dataParams.x_etb,
          labelsData  : dataLabels.x_etb,
          visibleAxis : true,
          visible     : visible,
          showInLegend : (!isActiveTabs || mchartEt_initial_label == "etb_prom")
        });



        visible = false;
        if(isActiveTabs ){
          visible = mchartEt_initial_label == "coef";
        }

        g.mchartEt.agregarSerie({
          color        : Config.colors.riegoProgramado.array[indexColor],
          labelsColor  : Config.colors.riegoProgramado.array[indexColor],
          name         : 'Coeficiente' + suffixLabel ,
          tag          : "coef",
          yAxis        : 19,
          lineWidth    : 2,
          suffix       : '',
          type         : 'spline',
          data         : dataParams.coeficiente,
          labelsData   : dataLabels.coeficiente,
          visibleAxis  : true,
          visible      : visible,
          showInLegend : (!isActiveTabs || mchartEt_initial_label == "coef")
        });





        // TODO: mejorar
        dataParams.eto_acum = [];
        dataLabels.eto_acum = [];
        for (var i = 0; i < dataParams.eto.length; i++) {
          dataParams.eto_acum[i] = [
            dataParams.eto[i][0],
            _.round(dataParams.eto[i][1] + ( i == 0 ?  0 : dataParams.eto_acum[i-1][1]),2),
          ];
          dataLabels.eto_acum[i] =  dataParams.eto_acum[i][1]+""

        }

        g.mchartEt.agregarSerie({
          color         : Config.colors.riegoProgramado.array[indexColor],
          labelsColor   : Config.colors.riegoProgramado.array[indexColor],
          name          : 'Sumatoria Et0 ' + suffixLabel ,
          tag           : "eto_acum",
          labelsPadding : paramsFn.isActive ? 0 : 30,
          alignLabels   : paramsFn.isActive ? "right" : "left",
          yAxis         : 13,
          lineWidth     : 2,
          suffix        : ' mm',
          type          : 'spline',
          data          : dataParams.eto_acum,
          labelsData    : dataLabels.eto_acum,
          labelsPadding : 10,
          visibleAxis   : true,
          visible       : Config.vinedo['estacionMet'] ,
          showInLegend  : true
        });




        // TODO: mejorar
        dataParams.etb_acum = [];
        dataLabels.etb_acum = [];
        for (var i = 0; i < dataParams.etb.length; i++) {
          dataParams.etb_acum[i] = [
            dataParams.etb[i][0],
            _.round(dataParams.etb[i][1] + ( i == 0 ?  0 : dataParams.etb_acum[i-1][1]),2),
          ];
          dataLabels.etb_acum[i] =  dataParams.etb_acum[i][1]+""

        }

        g.mchartEt.agregarSerie({
          color         : Config.colors.riegoProgramado.array[indexColor],
          labelsColor   : Config.colors.riegoProgramado.array[indexColor],
          name          : 'Sumatoria Etb ' + suffixLabel ,
          tag           : "etb_acum",
          labelsPadding : 10,
          positionLabel : "bottom",
          alignLabels   : "bottom",
          yAxis         : 13,
          lineWidth     : 2,
          suffix        : ' mm',
          type          : 'spline',
          data          : dataParams.etb_acum,
          labelsData    : dataLabels.etb_acum,
          visibleAxis   : true,
          visible       : !Config.vinedo['estacionMet'] ,
          showInLegend  : true
        });



      }



















      // GRADOS DIAS Y WINKLER
      if(withGD){
        vm.fechaInicioGradosDia_m = moment(vm.temporadaSelected.inicio, "YYYY-MM-DD").toDate();
        vm.recalcularGradosDias();
        var gdGrafico = vm.getGradosDiasGrafico(datesGradosDia);
        //grados dia
        _.eachRight(gdGrafico, function(gd, index){

          //bora labels, solo deja el ultimo
          var gdLabels = [];
          _.each(gd.labelsData, function(item, index){
            //para labels
            if(index < gd.labelsData.length - 1){
              gdLabels.push("");
            }else{
              gdLabels.push(item);
            }
          });


          if( vm.periodoSelected == PERIODO_FENOLOGIA ||
            vm.periodoSelected == PERIODO_MESES){
            gd.deltas = [];
            var ant = 0;
            _.each(gd.data, function(item, index){
              gd.deltas.push([
                item[0],
                _.round(item[1] - ant, 2)
              ]);
              ant = item[1];
            });

            if(vm.periodoSelected == PERIODO_MESES){
              gd.deltas = prepareGDMonths(gd.deltas);
              gd.data   = prepareGDMonths(gd.data);
            }



            g.mchartGD.agregarSerie({
              color       : Config.colors.gd.array[index],
              name        : 'delta GD '+gd.periodo,
              yAxis       : 0,
              lineWidth   : 2,
              suffix      : '',
              type        : 'column',
              tag         : "deltaGD",
              data        : gd.deltas,
              visibleAxis : true,
              visible     : vm.tabs.mchartGD.tabSelected == vm.tab_deltaGD,
              showInLegend: vm.tabs.mchartGD.tabSelected == vm.tab_deltaGD,
            });
          }


          g.mchartGD.agregarSerie({
            color       : Config.colors.gd.array[index],
            name        : 'Grados dia '+gd.periodo,
            yAxis       : 0,
            lineWidth   : 2,
            suffix      : '',
            type        : 'spline',
            tag: 'gd',
            data        : gd.data,
            labelsData  : gdLabels,
            visibleAxis : true,
            visible     : vm.tabs.mchartGD.tabSelected == vm.tab_gd,
            showInLegend: vm.tabs.mchartGD.tabSelected == vm.tab_gd,
          });

          /*
          g.mchartGD.agregarSerie({
            color       : Config.colors.gd.array[index],
            name        : 'Tasa GD '+gd.periodo,
            yAxis       : 0,
            suffix      : '',
            type        : 'column',
            data        : gd.tasas,
            visibleAxis : true,
            visible: index == 0
          });
        */

        });
        //END grados dia


        //Winkler
        vm.fechaInicioWinkler_m = moment("2017-10-01", "YYYY-MM-DD").toDate();
        vm.recalcularWinkler();
        var gdGrafico = vm.getGradosDiasGrafico(datesGradosDia, true);
        _.each(gdGrafico, function(gd, index){
          var gdLabels = [];
          _.each(gd.labelsData, function(item, index){
            if(index < gd.labelsData.length - 1){
              gdLabels.push("");
            }else{
              gdLabels.push(item);
            }
          });


          if( vm.periodoSelected == PERIODO_FENOLOGIA ||
            vm.periodoSelected == PERIODO_MESES){
            gd.deltas = [];
            var ant = 0;
            _.each(gd.data, function(item, index){
              gd.deltas.push([
                item[0],
                _.round(item[1] - ant, 2)
              ]);
              ant = item[1];
            });


            if(vm.periodoSelected == PERIODO_MESES){
              gd.deltas = prepareGDMonths(gd.deltas);
              gd.data   = prepareGDMonths(gd.data);
            }



            g.mchartGD.agregarSerie({
              color       : Config.colors.winkler.array[index],
              name        : 'delta Winkler '+gd.periodo,
              yAxis       : 0,
              lineWidth   : 2,
              suffix      : '',
              tag         : 'deltaWinkler',
              type        : 'column',
              data        : gd.deltas,
              visibleAxis : true,
              visible     : vm.tabs.mchartGD.tabSelected == vm.tab_winkler,
              showInLegend: vm.tabs.mchartGD.tabSelected == vm.tab_winkler,
            });
          }

          g.mchartGD.agregarSerie({
            color       : Config.colors.winkler.array[index],
            name        : 'winkler '+gd.periodo,
            yAxis       : 0,
            lineWidth   : 2,
            suffix      : '',
            type        : 'spline',
            tag         : 'winkler',
            data        : gd.data,
            labelsData  : gdLabels,
            visibleAxis : true,
            visible     : vm.tabs.mchartGD.tabSelected == vm.tab_deltaWinkler,
            showInLegend: vm.tabs.mchartGD.tabSelected == vm.tab_deltaWinkler,
          });
        });
        //END winkler
      }
      //END  GRADOS DIAS Y WINKLER



      vm.chart.loadingChart          = false;
      vm.chart.chartConfigReposicion = g.mchartRep.getConfig();
      vm.chart.chartConfigEt         = g.mchartEt.getConfig();
      vm.chart.chartConfigGD         = g.mchartGD.getConfig();
      vm.chart.chartConfigVol        = g.mchartVol.getConfig();


    }





    var params = [
      {
        label       : "volumen_ha",
        nombre      : "volumen Ha acum",
        labelSave   : "volumen_ha_acum",
        acumulative : true,
        zero        : null,
        default     : null,
        round       : 2,
      },
      {
        label       : "eto",
        nombre      : "Et0",
        zero        : null,
        default     : null,
        round       : 2,
      },
      {
        label       : "etb",
        nombre      : "Etb",
        zero        : null,
        default     : null,
        round       : 2,
      },
      {
        label       : "coeficiente",
        nombre      : "coeficiente",
        zero        : null,
        default     : null,
        round       : 2,
      },
      {
        label       : "x_eto",
        nombre      : "Et0 promedio",
        zero        : null,
        default     : null,
        round       : 1,
      },
      {
        label       : "x_etb",
        nombre      : "Etb promedio",
        zero        : null,
        default     : null,
        round       : 1,
      },
      {
        label       : "reposicion",
        nombre      : "Promedio Reposiciones",
        zero        : null,
        default     : null,
        round       : 1,
      },
      {
        label       : "reposicion_ideal",
        nombre      : "Reposición Teorica",
        zero        : null,
        default     : null,
        round       : 1,
      },
      {
        label       : "reposicion_eto",
        nombre      : "Reposición Et0",
        zero        : null,
        default     : null,
        round       : 1,
      },
      {
        label       : "reposicion_etb",
        nombre      : "Reposicion Etb",
        zero        : null,
        default     : null,
        round       : 1,
      },
      {
        label       : "riego_real",
        nombre      : "Riego Real",
        zero        : null,
        default     : null
      },
      {
        label       : "riego_teorico_eto",
        nombre      : "Riego Teorico Eto",
        zero        : null,
        default     : null,
        round       : 0,
      },
      {
        label       : "riego_teorico_etb",
        nombre      : "Riego Teorico Etb",
        zero        : null,
        default     : null,
        round       : 0,
      },
      {
        label       : "volumen_dif_eto",
        nombre      : "---",
        zero        : null,
        default     : null,
        round       : 0,
      },
      {
        label       : "volumen_dif_etb",
        nombre      : "---",
        zero        : null,
        default     : null,
        round       : 0,
      },
      {
        label       : "volumen_total",
        nombre      : "Volumen total",
        zero        : null,
        default     : null,
        round       : 0,
      },
      {
        label       : "volumen_ha",
        nombre      : "Volumen/ha",
        zero        : null,
        default     : null,
        round       : 1
      },
      {
        label       : "volumen_ha_teorico_etb",
        nombre      : "Volumen/ha teórico etb",
        zero        : null,
        default     : null,
        round       : 0,
      },
      {
        label       : "volumen_ha_teorico_eto",
        nombre      : "Volumen/ha teórico et0",
        zero        : null,
        default     : null,
        round       : 0,
      },
      {
        label       : "scholander",
        nombre      : "Scholander",
        zero        : null,
        default     : null,
        round       : 1,
      }
    ]







    /**
     * INICIALIZA datos para graficos generales
     * usa la lista params como referencia
      * */
    function initDataCharts(data){
      var dataParams     = {};
      var dataLabels     = {};
      var datesGradosDia = [];
      var val            = 0;
      var l              = 0;

      angular.forEach(params, function(param){
        if(param.labelSave === undefined){
          param.labelSave = param.label;
        }
        dataParams[param.labelSave] = [];
        dataLabels[param.labelSave] = [];
          if(param.acumulative){
            param.acumAux = 0;
          }
      });

      angular.forEach(data, function(item){

        //nombre para eje X
        var l = item.nombre;

        //datos para grados dias (nombre eje x , fecha_fin)
        var dateGd = moment(item.fecha_fin);
        datesGradosDia.push({
          name: l,
          date: dateGd
        });

        angular.forEach(params, function(param){

            if(item[param.label] == null){ // NULL
              dataParams[param.labelSave].push(
                [l, param.default]
              );
              dataLabels[param.label].push(param.default);
            }else if(item[param.label] == 0){
              dataParams[param.labelSave].push( // ZERO
                [l, param.zero]
              );
              dataLabels[param.labelSave].push(param.zero);
            }else{

              var val = item[param.label];
              if(param.acumulative){
                param.acumAux += val;
                val = param.acumAux;
              }
              if(param.round !== undefined){
                val = _.round(val, param.round);
              }else{
                val = _.round(val, 2);
              }

              dataParams[param.labelSave].push( // VALID
                [l, val]
              );
              dataLabels[param.labelSave].push(val);

            }

        });
      });



      return {
        dataParams: dataParams,
        dataLabels: dataLabels,
        datesGradosDia: datesGradosDia
      }
    }















    function getGeneralCharts(){
      return vm.generalCharts;
    }





    //--------------------------------------------------------------------------
    //------ VISTA DETALLE -------------------------------------------
    //--------------------------------------------------------------------------

    vm.listaSectores = [];
    vm.listaEquipos  = [];
    vm.chartsDetalle = [];



    vm.showDetalleSectores = function(dias) {
      vm.chartsDetalle = [];
      var lapso = "Temporada"

      var data = angular.copy(vm.dataHttp);
      if(dias){
        lapso             = dias + " días";
        var termino       = moment().subtract(1, "days").toDate();
        var inicio        = moment(termino).subtract(dias, "days").toDate();
        var temporada     = temporadaFac.dateToTemporada(inicio);
        data.fecha_inicio = inicio;
        data.fecha_fin    = termino;
        data.periodo      = temporada.periodo;
        //}else{
        //temporada
      }


      //HACK
      //data.fecha_inicio = new Date("2019-01-01");
      //data.fecha_fin = new Date("2019-01-31");

      var prom = estadisticaFac.getVinedoIdeal(data).$promise;
      //var prom = $http.get("/assets/test.json");



      $q.all([prom]).then(function(resArray) {
        var res = resArray[0];
        vm.listaSectores = [];
        vm.listaEquipos = [];

        angular.forEach(res.data, function(item) {//item.sectores[index].riegoIdeal
          vm.listaEquipos.push(item);
          var chartEquipo = {};
          vm.chartsDetalle.push(chartEquipo);
          chartEquipo.loadingChart = true;
          var dataChart = {
            title               : "Gráfico de " + lapso + " para "+item.nombre,
            sectores            : item.sectores,
            riegoIdeal          : [],
            riegoReal           : [],
            riegoProgramado     : [],
            porcentajeProgramado: [],
            porcentajeIdeal     : [],
            porcentajeReal      : [],
            etAcum              : [],
            axis                : []
          };
          angular.forEach(item.sectores, function(sector){
            dataChart.etAcum.push(_.round(sector.etAcum, 2));
            dataChart.riegoIdeal.push(_.round(sector.riegoIdeal, 2));
            dataChart.riegoReal.push(_.round(sector.riegoReal, 2));
            dataChart.riegoProgramado.push(_.round(sector.riegoProgramado, 2));
            dataChart.porcentajeProgramado.push(_.round(sector.porcentajeProgramado, 2));
            dataChart.porcentajeIdeal.push(_.round(sector.porcentajeIdeal, 1));
            dataChart.porcentajeReal.push(_.round(sector.porcentajeReal, 1));
            dataChart.axis.push(sector.nombre);
            vm.listaSectores.push(sector);
          });

          var mchart                 = vm.graficarDetalleSector(dataChart, chartEquipo);
          chartEquipo.mchart         = mchart.mchart;
          chartEquipo.chartConfig    = chartEquipo.mchart.getConfig();
          chartEquipo.loadingChart   = false;
          chartEquipo.height         = mchart.height;
        });



        var termino = moment().subtract(1, "days").toDate();
        if(dias){
          var inicio = moment(termino).subtract(dias, "days").toDate();
        }else{
          var inicio = moment(vm.temporadaSelected.fin).toDate();
        }

        CuartelRes.getTemporada({
          sector_riego_id : vm.listaSectores[0].id,
          fecha_inicio    : inicio,
          fecha_fin       : termino
        }).$promise.then(function(resTemporada){
          var ets = resTemporada.data.ets2;
          vm.etAcum = 0;
          _.each(ets, function(et){
            vm.etAcum += et.cantidad;
          });

          vm.loadingGeneral = false;

        });



      });
      return prom;
    }

    vm.graficarDetalleSector = function(dataChart, chartItem) {
      var mchart = new MultiChart(dataChart.title);
      var chartConfig = mchart.getConfig();

      mchart.deletePositioner();

      var fn = function(a) {
        var chart = a.target;
        var axis = chart.xAxis[0];
        if(axis === undefined){
          return;
        }

        var onYaxisRedraw = function() {
          for (var tickPos in axis.ticks) {
            if (axis.ticks[tickPos].label) {
              var $element = $(axis.ticks[tickPos].label.element);
              $element.unbind('click');
              $element.unbind('mouseleave');
              $element.unbind('mouseover');

              $element.css({
                fill: "#0d47a1",
                "font-size": "14px",
                "text-decoration": "underline",
                cursor: "pointer"
              });

              $element.on("mouseleave", function() {
                $(this).css({
                  "font-size": "14px",
                });
              });
              $element.on("mouseover", function() {
                $(this).css({
                  "font-size": "16px",
                });
              });

              $element.on("click", function(a) {
                $timeout(function() {
                  var sector = getSectorByName(a.currentTarget.textContent, dataChart.sectores);
                  vm.showDialogSector(a, sector);
                });
              });

            }
          }
        }
        onYaxisRedraw();
        axis.redraw(onYaxisRedraw);
      } // END fn



      mchart.addLoadFunction(fn);
      chartConfig.plotOptions.column = {
        maxPointWidth : 40
      }
      chartConfig.xAxis.alternateGridColor= '#f5f5f5';

      var params = [
        {
          nameParam : "riegoProgramado"
        },
        {
          nameParam: "porcentajeProgramado"
        },
        {
          nameParam : "riegoReal"
        },
        {
          nameParam: "riegoIdeal"
        },
        {
          nameParam: "porcentajeReal",
          defaultData: null
        },
        {
          nameParam: "porcentajeIdeal",
          defaultData: 0
        }
      ];

      var dataParams = [];
      var dataLabels = [];
      angular.forEach(params, function(param) {
        if (dataLabels[param.nameParam] == undefined) {
          dataLabels[param.nameParam] = [];
        }
        if (dataParams[param.nameParam] == undefined) {
          dataParams[param.nameParam] = [];
        }
        var defaultData = null;
        if(param.defaultData !== undefined){
          defaultData = param.defaultData;
        }

        angular.forEach(dataChart[param.nameParam], function (data, index) {
          if (data === null || data === 0) {
            dataParams[param.nameParam].push([dataChart.axis[index], defaultData]);
            dataLabels[param.nameParam].push(defaultData);
          }else{
            dataParams[param.nameParam].push([dataChart.axis[index], parseFloat(data)]);
            dataLabels[param.nameParam].push(parseFloat(data));
          }
        });
      });


      mchart.agregarSerie({
        color       : Config.colors.etAcumulado.background,
        name        : 'et Acum',
        yAxis       : 2,
        type        : 'column',
        data        : dataParams["etAcum"],
        labelsData  : dataLabels["etAcum"],
        visibleAxis : true,
        suffix      : ' mm',
      });



      mchart.agregarSerie({
        color       : Config.colors.riegoReal.background,
        name        : 'Riego Real',
        yAxis       : 2,
        type        : 'column',
        data        : dataParams["riegoReal"],
        labelsData  : dataLabels["riegoReal"],
        visibleAxis : true,
        suffix      : ' mm',
      });


      mchart.agregarSerie({
        color       : Config.colors.riegoIdeal.background,
        name        : 'Riego Teórico',
        yAxis       : 2,
        type        : 'column',
        data        : dataParams["riegoIdeal"],
        labelsData  : dataLabels["riegoIdeal"],
        visibleAxis : true,
        suffix      : ' mm',
      });


      mchart.agregarSerie({
        color       : Config.colors.riegoProgramado.background,
        name        : 'Riego Programado',
        yAxis       : 2,
        type        : 'column',
        data        : dataParams["riegoProgramado"],
        labelsData  : dataLabels["riegoProgramado"],
        visibleAxis : true,
        suffix      : ' mm',
      });

      mchart.agregarSerie({
        color       : Config.colors.porcentajeReal.contrast,
        name        : '% Rep Real',
        yAxis       : 19,
        type        : 'column',
        data        : dataParams["porcentajeReal"],
        labelsData  : dataLabels["porcentajeReal"],
        withLines   : true,
        visible: false,
        visibleAxis : true,
        suffix      : " %",
        oppositeAxis: true,
      });

      mchart.agregarSerie({
        color       : Config.colors.riegoProgramado.weekend,
        name        : '% Rep Programado',
        yAxis       : 19,
        type        : 'column',
        data        : dataParams["porcentajeProgramado"],
        labelsData  : dataLabels["porcentajeProgramado"],
        withLines   : true,
        visible: false,
        visibleAxis : true,
        suffix      : " %",
        oppositeAxis: true,
      });

      mchart.agregarSerie({
        color        : Config.colors.porcentajeIdeal.contrast, //Config.colors.riegoIdeal.background,
        name         : '% rep Teórico',
        yAxis        : 19,
        visibleAxis : true,
        oppositeAxis: true,
        withLines   : true,
        suffix      : " %",
        visible: false,
        type         : 'column',
        data         : dataParams["porcentajeIdeal"],
        labelsData   : dataLabels["porcentajeIdeal"],
      });


      var height         = mchart.getHeight();

      return {
        mchart    : mchart,
        height    : height
      };
    };














    //--------------------------------------------------------------------------
    //------ OPCIONES DE COMPARACION Sectores ----------------------------------
    //--------------------------------------------------------------------------

    vm.toggleComparisonSectorPanel = function(){
      vm.comparandoSectores = !vm.comparandoSectores;
      vm.comparando         = !vm.comparandoSectores;
      vm.optionsChanged     = true;
    }

    vm.selectSectoresComparacionCallback = function(dialogData){
      vm.sectoresSeleccionadosComparacion = dialogData.seleccionados;
      vm.optionsChanged     = true;
      if(dialogData === undefined){
        return false;
        console.error("dialogData undefined");
      }

      //vm.selectPeriodo(vm.periodoSelected);
    };






    //--------------------------------------------------------------------------
    //------ OPCIONES DE COMPARACION -------------------------------------------
    //--------------------------------------------------------------------------

    vm.hideComparisonPanel = function(){
      vm.comparandoSectores = false;
      vm.comparando         = false;
      vm.optionsChanged     = true;
    }

    vm.toggleComparisonPanel = function(){
      vm.comparando         = !vm.comparando;
      vm.optionsChanged     = true;
      vm.comparandoSectores = !vm.comparando;
    }

    vm.addTemporadaComparison = function(){
      vm.showAddComparison = true;
      vm.optionsChanged = true;
      if(vm.temporadasComparisonArray.length < vm.limitComparison){
        var ts = null;
        if(vm.temporadasComparisonArray.length == 0){
          ts = vm.temporadaSelected;
        }else{
          ts = vm.temporadasComparisonArray[vm.temporadasComparisonArray.length-1].selected;
        }
        var t = temporadaFac.getAnterior(ts);
        vm.temporadasComparisonArray.push({
          selected:t
        });
      }
      if(vm.temporadasComparisonArray.length == vm.limitComparison){
        vm.showAddComparison = false;
      }
    }

    vm.removeTemporadaComparison = function(index){
      vm.optionsChanged = true;
      vm.temporadasComparisonArray.splice(index, 1);
    }

    vm.comparar = function(){
      reload();
    }









   // --------------------------------------------------------------------------
   // ----------- Metodos para Manejo de fechas y Navegacion -------------------
   // --------------------------------------------------------------------------

    vm.changeView = function(view){
      if(vm.viewSelected == view){
        return;
      }

      vm.viewSelected = view;
      vm.reload();
      //TODO changeview debe detectar si es necesario un reload o no
    }

    vm.selectPeriodoSectores = function (periodoSector, reload) {
      vm.optionsChanged = true;
      vm.periodoSectorSelected = periodoSector;
      if(reload){
        vm.reload();
      }
    }

    vm.selectPeriodo = function (periodo, reload) {
      vm.optionsChanged = true;
      vm.periodoSelected = periodo;
      if(reload){
        vm.reload();
      }
    }

    // funcion llamada en el cambio de sectores
    // usado en la directiva selectSectores
    vm.selectSectoresCallback = function(dialogData){
      if(dialogData === undefined){
        return false;
        console.error("dialogData undefined");
      }
      vm.alertEmptySelect = false;
      if( !dialogData.all &&  dialogData.seleccionados.length == 0){
        vm.alertEmptySelect = true;
        return false;
      }
      if(dialogData.all){
        vm.sectoresSeleccionados = [];
        delete vm.dataHttp["sectores_riego_id[]"];
      }else{
        vm.sectoresSeleccionados = dialogData.seleccionados;
        vm.dataHttp["sectores_riego_id[]"] = dialogData.seleccionadosIds;
      }
      vm.selectPeriodo(vm.periodoSelected);
    };


    // $watch para ver cambio de fecha
    $scope.$watch(function() {
      return vm.dateSelected;
    }, function(n, o) {
      if (n != o) {
        vm.hideBackdrop();
        vm.selectPeriodo(vm.periodoSelected);
      }
    });


    vm.changeSemanas = function () {
      vm.selectPeriodo(vm.periodoSelected);
    };

    vm.changeTemporada = function (temporada) {
      PERIODO_FENOLOGIA.enabled = false;
      vm.dataHttp.periodo = vm.temporadaSelected.periodo;
      _.each(vm.temporadas, function(t){
        if(t.periodo == vm.temporadaSelected.periodo){
          PERIODO_FENOLOGIA.enabled = t.estados;
        }
      });
      vm.selectPeriodo(vm.periodoSelected);
    };

    var refreshTemporadas = function(fn){
      //vm.temporadas;
      var p = temporadaFac.getTemporadas(true, vm.dataHttp);
      p.then(function (res) {
        PERIODO_FENOLOGIA.enabled = false;
        vm.temporadas        = res.data.data;

        //para comparacion
        if(vm.temporadasComparisonArray.length == 0){
          var tActual = temporadaFac.getActiva();
          var ta1     = temporadaFac.getAnterior(tActual);
          var ta2     = temporadaFac.getAnterior(ta1);

          vm.temporadasComparisonArray = [
            {
              selected:ta1
            },
          ];
        }else{
          //HACK, actualiza los items de temporadasComparisonArray con
          //las nuevas temporadas, ya que los objetos no son los mismos
          _.each(vm.temporadas, function(t){
            _.each(vm.temporadasComparisonArray, function(tc, i){
              if(tc.selected.periodo == t.periodo){
                vm.temporadasComparisonArray[i].selected = t;
              }
            });
          });
        }

        if(vm.temporadaSelected.periodo !== null){
          //patch
          vm.temporadaSelected = temporadaFac.getByPeriodo(vm.temporadaSelected.periodo);
          _.each(res.data.data, function(t){
            if(t.periodo == vm.temporadaSelected.periodo){
              PERIODO_FENOLOGIA.enabled = t.estados;
            }
          });
        }

        fn();
      });
      return p;
    }

    vm.showSelectDate = function() {
      vm.showPopoverDate = true;
      vm.showBackdrop(function() {
        vm.showPopoverDate = false;
      });
    };

    vm.cancelSelectDate = function() {
      vm.showPopoverDate = false;
    };

    vm.dateToToday = function() {
      vm.dateSelected = new moment().set('minute', 0).set('second', 0).toDate().cleanHour();
    };

    function sortByMonth(arr) {
      arr.sort(function(a, b){
        return months.indexOf(a[0])
        - months.indexOf(b[0]);
      });
    }

    vm.atras = function(){
      switch (vm.periodoSelected){
        //case PERIODO_DIAS:
          //vm.atrasDias();
          //break;
        default:
          console.error("atras null");
      }
    };

    vm.adelante = function(){
      switch (vm.periodoSelected){
        case PERIODO_DIAS:
          vm.adelanteDias();
          break;
        default:
          console.error("atras null");
      }
    };



   // --------------------------------------------------------------------------
   // ----------- Metodos para grados dias -------------------------------------
   // --------------------------------------------------------------------------


    var prepareGDMonths = function(data){
      sortByMonth(data);
      var dataNew = [];
      _.each(months, function(m){
        var v = data.find(function(o){
          return o[0] == m
        });
        var d = (v == undefined) ? null : v[1];
        dataNew.push([m, d]);
      });
      return dataNew;
    }


    vm.changeDateGD = function(){
      //vm.fechaInicioGradosDia_m = fecha
      vm.recalcularGradosDias();
      vm.graficar();
    }



    vm.recalcularWinkler = function(){
      vm.winklerAcumulado= [];
      var fechaInicio = moment(vm.fechaInicioWinkler_m);
      _.each(vm.dataGradosDias, function(gdObj){
        var d = [];// winkler acumulados
        var aux = 0; //sumador
        var periodo = gdObj.periodo;
        _.each(gdObj.data, function(gd){
          var m = moment(gd.fecha);
          if(m.isAfter(fechaInicio)){
            aux += gd.winkler || 0;
          }
          d.push([gd.fecha,_.round(aux, 2)]);
        });
        vm.winklerAcumulado.push({
          periodo: periodo,
          data: d
        });
        fechaInicio.subtract(1, "year");
      });
    }




    vm.recalcularGradosDias = function(){
      vm.gradosDiasAcumulados = [];
      var fechaInicio = moment(vm.fechaInicioGradosDia_m);
      _.each(vm.dataGradosDias, function(gdObj){
        var d = [];// grados dias acumulados
        var aux = 0; //sumador
        var periodo = gdObj.periodo;

        gdObj.data.sort(function(a_d, b_d) {
          var a = new Date(a_d.fecha);
          var b = new Date(b_d.fecha);
          return a<b ? -1 : a>b ? 1 : 0;
        });


        _.each(gdObj.data, function(gd){
          var m = moment(gd.fecha);
          if(m.isSameOrAfter(fechaInicio)){
            aux += gd.grados_dia;
          }
          d.push([gd.fecha,_.round(aux, 2)]);
        });
        vm.gradosDiasAcumulados.push({
          periodo: periodo,
          data: d
        });
        fechaInicio.subtract(1, "year");
      });
    }




    vm.getGradosDiasGrafico = function(dates, isWinkler){
      //dates --> moment array
      //winkler
      var resArray = [];
      var gdAnterior = 0;
      var array = isWinkler ? vm.winklerAcumulado : vm.gradosDiasAcumulados;
      _.each(array, function(gdObj){
        var res = {
          periodo: gdObj.periodo,
          data:[],
          tasas:[],
          labelsData:[]
        };
        _.each(gdObj.data, function(gd){
          _.each(dates, function(date){
            var m = moment(gd[0]);
            //if(m.isSame(date.date, "day")){
              if(m.date() == date.date.date() &&
              m.month() == date.date.month()){
                res.data.push([date.name , gd[1]]);
                res.tasas.push([date.name , _.round(gd[1] - gdAnterior, 2)]);
                res.labelsData.push(gd[1]);
                gdAnterior = gd[1];
              }
            //}
          });
        });
        resArray.push(res);
      });
      /**
       * formato de return
       * [
       *    {
       *      data:[["", 0]]
       *      labelsData:[0]
       *      periodo:""
       *      tasas:[["", 0]]
       *    }
       * ]
       */
      return resArray;
    }



   // --------------------------------------------------------------------------
   // ----------- UTILS --------------------------------------------------------
   // --------------------------------------------------------------------------


    vm.openMenu = function($mdMenu, ev) {
      $mdMenu.open(ev);
    };

    vm.quitFilter = function(name){
      vm.filtros.items[name] = null;
      vm.filtros.onChange(vm.filtros.items);
    }

    vm.showDialogSector = function(ev, sector) {
      cuartelDialog.showDialog(ev, sector.id);
    }


    vm.showBackdrop = function(fn) {
      if (fn !== undefined && fn !== null) {
        hideBackdropCallback = fn;
      }
      vm.showedBackdrop = true;
    };

    vm.hideBackdrop = function() {
      if (hideBackdropCallback !== null) {
        hideBackdropCallback();
        hideBackdropCallback = null;
      }
      vm.showedBackdrop = false;
    };


    // -- RESIZE --------------
    var resizeFn = function() {
      if(global.responsiveIs("xs sm")){
        vm.isMobile = true;
        vm.fullHeight = $(document).height() - 60;
      }else{
        vm.fullHeight = $(document).height() - 90;
      }
    };
    $(window).resize(resizeFn);
    $("#content").resize(resizeFn);
    resizeFn();
    // -- END RESIZE -----------

    function getSectorByName (name, sec) {
      var ret = null;
      var sectores = sec === undefined ? vm.listaSectores : sec;
      angular.forEach(sectores, function(sector) {
        if (sector.nombre == name) {
          ret = sector
        }
      });
      return ret;
    }




    vm.print = function(){
      window.print();
    }






    vm.init();


    // temporal

    vm.showProgramaFertWireframe = function(ev){
      $mdDialog.show({
        controllerAs        : 'pf',
        templateUrl         : 'components/vinedo/newtimeline/programaFertTable/programaFertTable.tmpl.html',
        parent              : angular.element(document.body),
        targetEvent         : ev,
        clickOutsideToClose : true,
        controller: "programaFertTableCtrl"
      })
    };








  }
})();
